/* Tarjetas de producto: pasar/enfocar un swatch previsualiza la imagen de ese color;
   clic/tap/Enter navega a la ficha con ese color puesto (?variant=ID); el botón "+N"
   despliega todos los colores. Delegado en document para que funcione también con
   tarjetas inyectadas (scroll infinito, carruseles, favoritos). */
(function () {
  function card(el) { return el && el.closest ? el.closest('.product-card') : null; }
  function mainImg(c) { return c ? c.querySelector('.product-card__media img') : null; }

  /* Intercambia src + srcset (hay que sobrescribir srcset o el navegador ignora el src). */
  function applySrc(img, src, srcset) {
    if (!img || img.getAttribute('src') === src) return;
    img.style.transition = 'none';
    img.style.opacity = '0';
    img.setAttribute('src', src);
    img.setAttribute('srcset', srcset || src);
    requestAnimationFrame(function () {
      img.style.transition = '';
      img.style.opacity = '';
    });
  }

  function preload(url, cb) {
    if (!url) { if (cb) cb(); return; }
    var im = new Image();
    if (cb) { im.onload = cb; im.onerror = cb; }
    im.src = url;
    if (im.complete && cb) cb();
  }

  function showColor(sw) {
    var c = card(sw);
    var img = mainImg(c);
    var url = sw.getAttribute('data-swatch-img');
    if (!img || !url) return;
    if (!img.hasAttribute('data-pc-src')) {
      img.setAttribute('data-pc-src', img.getAttribute('src') || '');
      img.setAttribute('data-pc-srcset', img.getAttribute('srcset') || '');
    }
    preload(url, function () { applySrc(img, url, url); });
  }

  function resetCard(c) {
    var img = mainImg(c);
    if (!img || !img.hasAttribute('data-pc-src')) return;
    applySrc(img, img.getAttribute('data-pc-src'), img.getAttribute('data-pc-srcset'));
  }

  /* Precarga diferida de las imágenes de variante al primer contacto con la tarjeta. */
  function warm(wrap) {
    if (!wrap || wrap.hasAttribute('data-pc-warm')) return;
    wrap.setAttribute('data-pc-warm', '');
    var run = function () {
      wrap.querySelectorAll('.pc-swatch[data-swatch-img]').forEach(function (s) {
        preload(s.getAttribute('data-swatch-img'));
      });
    };
    if ('requestIdleCallback' in window) window.requestIdleCallback(run, { timeout: 1500 });
    else setTimeout(run, 300);
  }

  function toggleMore(btn) {
    var wrap = btn.closest('.pc-swatches');
    if (!wrap) return;
    var open = wrap.classList.toggle('is-expanded');
    btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    btn.textContent = open ? '−' : (btn.getAttribute('data-more-text') || btn.textContent);
    btn.setAttribute(
      'aria-label',
      open ? (btn.getAttribute('data-label-collapse') || btn.getAttribute('aria-label') || '')
           : (btn.getAttribute('data-label-expand') || btn.getAttribute('aria-label') || '')
    );
  }

  function swatchAt(target) {
    return target && target.closest ? target.closest('.pc-swatch[data-swatch-img]') : null;
  }
  function navSwatch(target) {
    return target && target.closest ? target.closest('.pc-swatch[data-variant-url]') : null;
  }
  function moreAt(target) {
    return target && target.closest ? target.closest('[data-more-toggle]') : null;
  }
  function goToVariant(sw) {
    var url = sw.getAttribute('data-variant-url');
    if (url) window.location.href = url;
  }

  /* --- Ratón: hover entra/sale del área de swatches --- */
  document.addEventListener('mouseover', function (e) {
    var sw = swatchAt(e.target);
    if (sw) { warm(sw.parentElement); showColor(sw); }
  });
  document.addEventListener('mouseout', function (e) {
    var wrap = e.target.closest ? e.target.closest('.pc-swatches') : null;
    if (wrap && !wrap.contains(e.relatedTarget)) resetCard(card(wrap));
  });

  /* --- Teclado: foco dentro/fuera de los swatches --- */
  document.addEventListener('focusin', function (e) {
    var sw = swatchAt(e.target);
    if (sw) { warm(sw.parentElement); showColor(sw); }
  });
  document.addEventListener('focusout', function (e) {
    var wrap = e.target.closest ? e.target.closest('.pc-swatches') : null;
    if (wrap && !wrap.contains(e.relatedTarget)) resetCard(card(wrap));
  });

  /* --- Clic / tap: navega a la ficha con ese color; "+N" expande. Nunca sigue el enlace de la tarjeta --- */
  document.addEventListener('click', function (e) {
    var more = moreAt(e.target);
    if (more) { e.preventDefault(); e.stopPropagation(); toggleMore(more); return; }
    var sw = navSwatch(e.target);
    if (sw) { e.preventDefault(); e.stopPropagation(); goToVariant(sw); }
  });

  /* --- Enter / Espacio: navega (swatch) o expande ("+N") --- */
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' && e.key !== ' ' && e.key !== 'Spacebar') return;
    var more = moreAt(e.target);
    if (more) { e.preventDefault(); toggleMore(more); return; }
    var sw = navSwatch(e.target);
    if (sw) { e.preventDefault(); goToVariant(sw); }
  });
})();
